module.exports = __webpack_public_path__ + "img/sdc2018-team1.481cd88b.png";